import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'name',
  label: {
    default: 'Name',
    short: 'Name',
  },
});
